// extracted by mini-css-extract-plugin
export var container = "_ec-1";
export var editor = "_ec-2";
export var resizable = "_ec-3";
export var wrapper = "_ec-0";